module.exports = __webpack_public_path__ + "img/clamp_L.0c5c1f1a.png";